 <script setup lang="ts">
  import { fmt } from '@/functions'

  const view = defineModel<string>('view', { required: true })
  const month = defineModel<number>('month', { required: true })
  const year = defineModel<number>('year', { required: true })

  const btnPrevClick = () => {
    if (view.value === 'months') {
      year.value--
    } else if (view.value === 'days') {
      if (month.value === 0) {
        month.value = 11
        year.value--
      } else {
        month.value--
      }
    }
  }
  const btnNextClick = () => {
    if (view.value === 'months') {
      year.value++
    } else if (view.value === 'days') {
      if (month.value === 11) {
        year.value++
        month.value = 0
      } else {
        month.value++
      }
    }
  }
  const viewUp = () => {
    if (view.value === 'days') {
      view.value = 'months'
    }
  }
</script>

<template>
  <div class="flex gap-4 text-sm">
    <app-button
      class="px-2"
      @click="btnPrevClick">
      <fa-icon icon="i-far-arrow-left" />
    </app-button>

    <app-button
      class="flex-1"
      @click="viewUp">
      <template v-if="view === 'months'">
        {{ year }}
      </template>
      <template v-else>
        {{ fmt.date(new Date(year, month), 'MMMM') }} {{ year }}
      </template>
    </app-button>

    <app-button
      class="px-2"
      @click="btnNextClick">
      <fa-icon icon="i-far-arrow-right" />
    </app-button>
  </div>
</template>
